<a [routerLink]="active ? resolvedCommands : undefined" class="button" [ngClass]="{'loading': isLoading, 'sectionHover' : sectionVisible}" [routerLinkActive]="active ? 'active' : ''" [routerLinkActiveOptions]="{ exact: exact }" (click)="active ? onClick() : null">
  <div class="icon" [style.--icon]="iconCss"></div>
  <div>{{ label }}</div>
</a>
